import { Position } from '../types/protocol.js';
import { RecordPositionBase } from '../types/record.js';
import { getToleranceRange } from './getToleranceRange.js';


/**
 * Determines if the given position is outside the tolerance range.
 * Handles both measurement and visual inspection positions.
 * Returns false if the value is null or an empty string.
 * Returns true if the value is outside the tolerance range.
 * Also returns `true` if the value is a non-empty string, but cannot be parsed as a number.
 * 
 * @param position - The position to check.
 * @param recordPos - The value to check against the position's tolerance range.
 * @returns `true` if the value is outside the tolerance range, `false` otherwise.
 * @throws {Error} If the position is not a measurement.
 */
export function isOutOfSpec(position: Position, recordPos: RecordPositionBase<any>): boolean {
    if (position.type === 'measurement') {
        if (recordPos.value == null || recordPos.value === '') return false;
        const valueAsNumber = parseFloat(recordPos.value as string);
        const { min, max } = getToleranceRange(position);
        const isOutOfSpec = isNaN(valueAsNumber) || valueAsNumber < min || valueAsNumber > max;
        return isOutOfSpec;
    } else {
        if (recordPos.value == null) return false;
        return !(recordPos.value as boolean);
    }
}

export function isOutOfSpecValue(position: Position, value: number): boolean {
    const { min, max } = getToleranceRange(position);
    const isOutOfSpec = isNaN(value) || value < min || value > max;
    return isOutOfSpec;
}
